import { useEffect, useState } from 'react'

import { useProposal } from '@itau-loans-www/hooks'
import { http } from '@itau-loans-www/services'
import auth from '@itau-loans-www/services/http/auth'

const useBankDataForm = (formProps, initialValues) => {
  const [banks, setBanks] = useState([])
  const [loading, setLoading] = useState(false)

  const { product } = useProposal()

  const productCode = product?.proposal?.productCode

  const options = banks.map((bank) => {
    return {
      label: `${bank['bank_code']} - ${bank['bank_name']}`,
      value: bank['bank_code']
    }
  })

  useEffect(() => {
    auth({})
      .then(async () => {
        setLoading(true)
        const bankData = await http.proposal.getBanks(productCode)
        setBanks(bankData)

        const bank = bankData.find(
          (item) => item.bank_code === initialValues?.bank_code?.value
        )

        if (bank?.bank_code && bank?.bank_name) {
          formProps.setValue('bank', `${bank?.bank_code} - ${bank?.bank_name}`)
        }
      })
      .finally(() => setLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    options,
    loading
  }
}

export default useBankDataForm
